module.exports = __webpack_public_path__ + "static/circe-light-35-fcff34ec64e71eb0d96c580ad4468343.otf";